export default "__VITE_ASSET__d678737a__"